import { Zap, Snowflake, ScanLine, PoundSterling } from "lucide-react";

const CARDS = [
  {
    tag: "01 · APPLY",
    title: "Tell us where.",
    body: "High-street cafés, gyms, offices, student halls, shopping centres. If you have high footfall, we have a machine for you.",
    accent: "cyan",
    icon: ScanLine,
    span: "md:col-span-7 md:row-span-2",
  },
  {
    tag: "02 · WE INSTALL",
    title: "Zero upfront.",
    body: "Frostico ships, installs and services the machine. You just plug it in.",
    accent: "pink",
    icon: Zap,
    span: "md:col-span-5",
  },
  {
    tag: "03 · SERVE",
    title: "Cups of dreamy soft-serve, 24/7.",
    body: "Real dairy soft-serve, toppings and sauces — dispensed in under 15 seconds. Cashless.",
    accent: "cyan",
    icon: Snowflake,
    span: "md:col-span-5",
  },
  {
    tag: "04 · EARN",
    title: "15% of every scoop.",
    body: "Transparent monthly payouts. Live dashboard for every location partner.",
    accent: "pink",
    icon: PoundSterling,
    span: "md:col-span-7",
    highlight: true,
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="relative py-24 md:py-36">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex items-end justify-between gap-8 mb-16 flex-col md:flex-row">
          <div>
            <div className="font-mono-accent text-[11px] text-[#5AB0FF] mb-4">
              How it works
            </div>
            <h2 className="font-display text-5xl md:text-7xl font-bold tracking-tighter max-w-3xl leading-[0.95]">
              A vending machine that <span className="italic text-white/80">pays you</span>.
            </h2>
          </div>
          <p className="max-w-md text-white/60 md:text-right leading-relaxed">
            No stock to manage. No staff to train. Just a beautiful piece of
            kit that turns your floor space into a monthly cheque.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {CARDS.map((c) => {
            const Icon = c.icon;
            const accent =
              c.accent === "pink" ? "text-[#8B5CF6]" : "text-[#5AB0FF]";
            return (
              <div
                key={c.tag}
                data-testid={`how-card-${c.tag.split(" ")[0]}`}
                className={`group relative rounded-2xl border border-white/10 bg-[#15161C] p-8 md:p-10 overflow-hidden transition-colors duration-300 hover:border-white/25 ${c.span} ${
                  c.highlight ? "bg-gradient-to-br from-[#15161C] to-[#1a1420]" : ""
                }`}
              >
                <div className="flex items-start justify-between mb-8">
                  <div className={`font-mono-accent text-[11px] ${accent}`}>
                    {c.tag}
                  </div>
                  <Icon size={20} className={accent} />
                </div>
                <h3 className="font-display text-3xl md:text-5xl font-bold tracking-tight leading-tight">
                  {c.title}
                </h3>
                <p className="mt-4 text-white/60 max-w-md leading-relaxed">
                  {c.body}
                </p>
                <div className="tick-line absolute bottom-0 left-0 right-0 h-6 opacity-40 group-hover:opacity-80 transition-opacity" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
